import {HyperDropComponent} from "./HyperDropComponent";

export class HyperDropToast extends HyperDropComponent {

  onMount(): void {

  }

  show(type: string = 'info', message: string, duration: number,closable: boolean,) {
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.innerHTML = `
      <div class="toast-message">${message}</div>
      ${closable ? '<button class="toast-close" aria-label="Close">&times;</button>' : ''}
    `;
    this.elements.container.appendChild(toast);
    let closeBtn = toast.querySelector('.toast-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.hide(toast));
    }
    requestAnimationFrame(() => {
      toast.classList.add('show');
    });


    //console.log(duration)
    if (duration > 0) {
      setTimeout(() => this.hide(toast), duration);
    }
  }

  hide(toastElement: HTMLElement) {
    toastElement.classList.remove('show');
    toastElement.addEventListener('transitionend', () => toastElement.remove(), { once: true });
    this.emit(toastElement, 'toast:hide');
  }

}
